<template>
    <div v-bind:class="[large ? 'container-md' : 'container']">
        <div class="row" v-bind:class="{ 'justify-content-center': !left }">
            <div v-bind:class="colClass">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            left: {
                type: Boolean,
                default: false,
            },
            large: {
                type: Boolean,
                default: false,
            },
            customColumn: {
                type: String,
                default: "",
            }
        },
        computed: {
            colClass() {
                return this.customColumn || (this.large ? "col-md-10 col-lg-8 col-xl-7" : "col-md-9 col-lg-7 col-xl-6");
            },
        },
    }
</script>